/**
 * `Intl` formatters are expensive to build and cheap to reuse, so every
 * formatter in this folder goes through one cache keyed by locale + options.
 * The option objects here are small, flat literals, so a JSON key is exact.
 */

const dateFormats = new Map<string, Intl.DateTimeFormat>();
const numberFormats = new Map<string, Intl.NumberFormat>();

function keyOf(locale: string | undefined, options: object): string {
  return `${locale ?? ''}|${JSON.stringify(options)}`;
}

/** A cached `Intl.DateTimeFormat`; `locale` `undefined` is the runtime default. */
export function dateTimeFormat(
  locale: string | undefined,
  options: Intl.DateTimeFormatOptions
): Intl.DateTimeFormat {
  const key = keyOf(locale, options);
  let format = dateFormats.get(key);
  if (!format) {
    format = new Intl.DateTimeFormat(locale, options);
    dateFormats.set(key, format);
  }
  return format;
}

/** A cached `Intl.NumberFormat`; `locale` `undefined` is the runtime default. */
export function numberFormat(
  locale: string | undefined,
  options: Intl.NumberFormatOptions
): Intl.NumberFormat {
  const key = keyOf(locale, options);
  let format = numberFormats.get(key);
  if (!format) {
    format = new Intl.NumberFormat(locale, options);
    numberFormats.set(key, format);
  }
  return format;
}
